export default __webpack_public_path__ + "static/media/phone_icon_telemor.25e1ea6f.png";